import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

export default function Pricing({ plans }) {
  return (
    <section id="pricing" className="bg-[#FAF9F5] py-24 lg:py-32" data-testid="pricing-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHead
          index="04"
          label="Pricing"
          title="Transparent slabs. No hidden cuts."
          description="Whether you run one counter or a ten-thousand-agent network, commissions are published upfront."
          testId="pricing-head"
        />
        <div className="grid gap-6 lg:grid-cols-3">
          {(plans || []).map((p, i) => (
            <Reveal key={i} delay={i * 0.1} className="h-full">
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                className={`relative flex h-full flex-col rounded-2xl border p-8 ${
                  p.highlight
                    ? "border-[#B8860B]/60 bg-gradient-to-br from-white to-[#FBF6EA] shadow-[0_24px_60px_-24px_rgba(184,134,11,0.35)]"
                    : "border-[#E2DDD5] bg-white shadow-sm"
                }`}
                data-testid={`pricing-card-${i}`}
              >
                {p.highlight && (
                  <span className="absolute -top-3 left-8 rounded-full bg-[#B8860B] px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.15em] text-white">
                    Most Popular
                  </span>
                )}
                <h3 className="font-syne text-xl font-bold text-[#0F1B2B]">{p.name}</h3>
                <p className="mt-1 text-sm text-[#8896AB]">{p.tagline}</p>
                <div className="mt-6 flex items-baseline gap-2">
                  <span className={`font-syne text-4xl font-extrabold tracking-tight ${p.highlight ? "text-gold" : "text-[#0F1B2B]"}`}>{p.price}</span>
                  <span className="font-mono text-xs text-[#8896AB]">{p.period}</span>
                </div>
                <ul className="mt-7 flex-1 space-y-3.5">
                  {(p.features || []).map((f, fi) => (
                    <li key={fi} className="flex items-start gap-2.5 text-sm text-[#45536A]">
                      <Check size={15} className="mt-0.5 shrink-0 text-[#0E8A8A]" />
                      {f}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  data-testid={`pricing-cta-${i}`}
                  className={`mt-8 block rounded-full py-3 text-center text-sm font-bold transition-all duration-300 active:scale-95 ${
                    p.highlight
                      ? "bg-[#1B3A5C] text-white hover:bg-[#0E8A8A] hover:shadow-[0_16px_40px_-12px_rgba(14,138,138,0.5)]"
                      : "border border-[#E2DDD5] text-[#0F1B2B] hover:border-[#0E8A8A]/50 hover:text-[#0E8A8A]"
                  }`}
                >
                  {p.ctaLabel || "Get Started"}
                </a>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
